import styled from 'styled-components';

interface ArtistCardProps {
  img: string;
  name: string;
  part: string;
}

const Container = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 6px;
  width: 22rem;
  text-align: center;
  margin: 3rem auto;
  padding: 2rem 0.4rem;
  cursor: pointer;
`;

const ImgWrapper = styled.div`
  padding: 1rem 0;

  img {
    border-radius: 8px;
  }
`;

const Name = styled.div`
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0.8rem 0;
`;

const Part = styled.div`
  font-size: 1.2rem;
  margin: 2rem 0 0.4rem;
`;

function ArtistCard({ img, name, part }: ArtistCardProps): React.ReactElement {
  return (
    <Container>
      <ImgWrapper>
        <img src={img} alt={`${name}'s imgage`} />
      </ImgWrapper>
      <Name>{name}</Name>
      <Part>{part}</Part>
    </Container>
  );
}

export default ArtistCard;
